import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';

type Props = {
  title: string;
  details: ReactNode;
};

const DetailsAccordion: React.FC<Props> = ({ title, details }: Props): ReactElement => {
  return (
    <Accordion variant="outlined">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box py={2.5}>
          <Typography variant="subtitle1-medium" color="textPrimary">
            {title}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>{details}</AccordionDetails>
    </Accordion>
  );
};

export { DetailsAccordion };
